import { FC, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { DatePickerComponent } from '@inputs/DatePickerComponents/DatePickerComponent';
import StarIcon from '@icons/star_required_icon.svg?component';
import { IDatePickerRowProps } from './types';

const DatePickerRow: FC<IDatePickerRowProps> = ({
  startName,
  endName,
  startPlaceholder,
  endPlaceholder,
  label,
  endLabel,
  requiredStart = false,
  requiredEnd = false,
  noMaxDateStart = false,
  noMaxDateEnd = false,
  minDateStart,
  minDateEnd,
  isTwoRows = false,
  stylesProp,
  isDisabledStart = false,
  isDisabledEnd = false,
  showRequiredIcons = false,
}) => {
  const formContext = useFormContext();
  const { watch } = formContext;

  const getLabelStyle = useCallback(
    (gridArea: 'start' | 'end') => {
      return isTwoRows ? 'label !mb-0' : `label [grid-area:${gridArea}] max-h-[32px]`;
    },
    [isTwoRows]
  );

  return (
    <>
      <div
        className={
          isTwoRows
            ? 'flex flex-col gap-y-[12px]'
            : `w-full grid grid-cols-2 gap-x-[32px] relative [grid-template-areas:'start_end''date_date']`
        }
      >
        {label && (
          <div className={getLabelStyle('start')}>
            <p>{label}</p>
            {showRequiredIcons && requiredStart && <StarIcon width={12} height={12} />}
          </div>
        )}
        <DatePickerComponent
          name={startName}
          placeholder={startPlaceholder}
          required={requiredStart}
          isClearable
          noMaxDate={!watch(endName) && noMaxDateStart}
          maxDate={watch(endName) ? new Date(watch(endName)) : undefined}
          minDate={minDateStart}
          stylesProp={stylesProp?.styleProps}
          buttonStyleProp={stylesProp?.buttonStyleProp}
          isDisabled={isDisabledStart}
        />
        {endLabel && (
          <div className={getLabelStyle('end')}>
            <p>{endLabel}</p>
            {showRequiredIcons && requiredEnd && <StarIcon width={12} height={12} />}
          </div>
        )}
        <DatePickerComponent
          name={endName}
          placeholder={endPlaceholder || 'Now'}
          required={requiredEnd}
          minDate={minDateEnd || new Date(watch(startName))}
          isClearable
          isDisabled={!watch(startName) || isDisabledEnd}
          noMaxDate={noMaxDateEnd}
          stylesProp={stylesProp?.styleProps}
          buttonStyleProp={stylesProp?.buttonStyleProp}
        />
      </div>
    </>
  );
};

export default DatePickerRow;
